import axios from 'axios';
import * as config from "../config";

export const ADMIN_COMPANIES_REQUEST= "ADMIN_COMPANIES_REQUEST";
export const ADMIN_COMPANIES_SUCESS= "ADMIN_COMPANIES_SUCESS";
export const ADMIN_COMPANIES_ERROR= "ADMIN_COMPANIES_ERROR";
export const ADMIN_COMPANIES_CHANGE_COUNT= "ADMIN_COMPANIES_CHANGE_COUNT";
export const ADMIN_COMPANIES_CHANGE= "ADMIN_COMPANIES_CHANGE";
export const ADMIN_COMPANIES_FILTERS_RESET= "ADMIN_COMPANIES_FILTERS_RESET";

export function Get(offset,size,name,filters) {
    return(dispatch)=>{
        dispatch({
            type:ADMIN_COMPANIES_REQUEST
        });

        axios.get(
            config.apiUrl + "/companies/all",
            {
                params:{
                    offset:offset,
                    size:size,
                    name:name,
                    isActive:filters.status,
                    shard:filters.shard
                }
            }
        ).then((response)=>{
            dispatch({
                type:ADMIN_COMPANIES_SUCESS,
                payload:response.data.content
            })
        }).catch((error)=>{
            dispatch({
                type:ADMIN_COMPANIES_ERROR
            })
        })
    }
}

export function ChangeCount(count) {
    return(dispatch)=>{
        dispatch({
            type:ADMIN_COMPANIES_CHANGE_COUNT,
            payload:count
        });
    }
}


export function Change(field,value){
    return (dispatch) =>{
        dispatch({
            type:ADMIN_COMPANIES_CHANGE,
            payload:{
                field,
                value
            }
        })
    }
}

export function FiltersReset() {
    return(dispatch) =>{
        dispatch({
            type:ADMIN_COMPANIES_FILTERS_RESET
        })
    }
}


// WEBPACK FOOTER //
// ./src/actions/adminCompaniesActions.js